import { getSafeOrDefault } from "../../../services/common/object-util";

export const resolvePlayerName = (player) => {
    return getSafeOrDefault(
        () => `${player.firstName || ""} ${player.lastName || ""}`.trim(),
        ""
    );
};

export const findPlayer = (players, player) => {
    return players.find((p) => {
        if (player.uniform) {
            return p.uniform === player.uniform;
        } else {
            return compareByFullName(player, p) === 0;
        }
    });
};

export const getFullName = ({ firstName, lastName }) => {
    return [firstName, lastName].filter((n) => n).join(" ");
};

export const compareByFullName = (a, b) => {
    return getFullName(a).localeCompare(getFullName(b), undefined, {
        sensitivity: "base"
    });
};
